import * as React from 'react';
import { Button, Panel } from '@ixicare/ui';
import { useNavigate } from 'react-router-dom';
import siteWrapper, { SiteWrapperProps } from '../utils/siteWrapper';
import styles from './Map.module.css';
import SitePlaneMapContainer from '../containers/SitePlaneMap';
import { t } from '~i18n';

interface SitePlaneUpdatePageProps extends SiteWrapperProps {
  planeId: number;
}

const SitePlaneUpdatePage: React.FC<SitePlaneUpdatePageProps> = ({ site, planeId }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.FitViewport}>
      <Panel className={styles.FitPanel}>
        <Panel.Right>
          <Button buttonType="inverse" onClick={() => navigate(`/sites/${site.uuid}/${planeId}/edit`)}>
            {t('site.floors.editDrawTool')}
          </Button>
        </Panel.Right>
        <div className={styles.MapWrapper}>
          <SitePlaneMapContainer site={site} initialPlaneId={planeId} />
        </div>
      </Panel>
    </div>
  );
};

export default siteWrapper(SitePlaneUpdatePage, ({ query }) => {
  const { planeId } = query;
  return {
    planeId: parseInt(planeId, 10),
  };
});
